$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
Browser = require '@trello/browser'
CardLabelSelectView = require 'app/scripts/views/label/card-label-select-view'
CardMemberSelectView = require 'app/scripts/views/card/card-member-select-view'
CardViewHelpers = require 'app/scripts/views/card/card-view-helpers'
CardViewMixins = require './card-view-mixins'
Controller = require 'app/scripts/controller'
DatePickerView = require 'app/scripts/views/card/date-picker-view'
Dates = require 'app/scripts/lib/dates'
require 'app/scripts/views/internal/data-transfer/drag-drop-events'
DragSort = require 'app/scripts/views/lib/drag-sort'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ getKey, Key, registerShortcutHandler, Scope, unregisterShortcutHandler, } = require '@trello/keybindings'
LabelKeyHelper = require 'app/scripts/views/label/label-key-helper'
PasteInput = require 'app/scripts/views/internal/paste-input'
PopOver = require 'app/scripts/views/lib/pop-over'
PostRender = require 'app/scripts/views/lib/post-render'
Promise = require 'bluebird'
Queue = require 'promise-queue'
{ Storage } = require '@trello/storage'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
{ Apdex } = require '@trello/atlassian-analytics'
log = require 'app/scripts/debug/log'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
{ track } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
f = require 'effing'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
cardTemplate = require 'app/scripts/views/templates/card_in_list'

{ renderName, openQuickCardEditor } = require './card-view-name-edit'
{ showCover } = require './card-view-cover'
{ labelClick, labelMouseEnter, labelMouseLeave } = require './card-view-label'
{ dragenter, dragleave, dropFiles, dropUrl } = require './card-view-attachment'
{ moveTo, moveIn } = require './card-view-lists'
{ isOnBoardTemplate } = require './card-view-templates'
{ addNewStickerToList, showStickers, renderStickers, renderCustomFieldItems, renderPluginBadges, renderPowerUpEffects, moveToCalendarDay, moveInCalendarDay, renderDueComplete } = require './card-view-plugins'

CARD_AGING_POWER_UP_ID = require('app/scripts/data/legacy-power-ups').cardAging

HOOK_DROPPABLE_QUEUE = new Queue(1)
enqueueDroppable = (cardView) ->
  HOOK_DROPPABLE_QUEUE.add ->
    new Promise (resolve) ->
      cardView.hookDroppable()
      _.defer resolve
      return
  return

module.exports = mixin CardViewHelpers, class CardView extends View
  _.extend(@prototype, CardViewMixins)

  className: ->
    baseClassName = 'list-card js-member-droppable'

    if @model.get('cover')? && featureFlagClient.get('remarkable.prerender-covers', false)
      { size, brightness, color, scaled, idAttachment, idUploadedBackground } = @model.get('cover')
      if size == 'full' && @shouldRenderFullCover()
        brightnessDarkClass = if brightness == 'dark' then 'full-cover-list-card-dark' else ''
        colorCoverClass = if color && @shouldRenderColorCover() then "color-card-cover color-card-cover-#{color}" else ''
        return "#{baseClassName} full-cover-list-card #{brightnessDarkClass} #{colorCoverClass}"

    return baseClassName

  tagName: 'a'

  attributes: ->
    if @model.get('cover')? && featureFlagClient.get('remarkable.prerender-covers', false)
      { size, idAttachment, idUploadedBackground } = @model.get('cover')

      if (idAttachment || idUploadedBackground) && size == 'full' && @shouldRenderFullCover()
        return {
          style: @getFullCoverStylesForInitialRender()
        }

    return {}

  filterDeactivated: true
  applyBoardCardFilter: true
  trackApdex: true

  events:
    'moveto': 'moveTo'
    'movein': 'moveIn'

    'moveToCalendarDay': 'moveToCalendarDay'
    'moveInCalendarDay': 'moveInCalendarDay'

    'click .js-open-quick-card-editor': 'openQuickCardEditor'
    'click .js-member-on-card-menu': 'openMemberOnCardMenu'
    'click .card-label.mod-card-front': 'labelClick'
    'click .js-due-date-badge': 'toggleDueDateComplete'
    'click': 'showDetail'

    'contextmenu': (e) ->
      # If they've got a modifier key pressed, maybe they're trying to get at the
      # system version of the context menu.  Also let developers opt out of it
      # completely with a localStorage key
      if e.ctrlKey || e.metaKey || e.shiftKey || Storage.get('nocontext')
        return

      @openQuickCardEditor(e)

    'mouseenter': -> @trigger 'mouseEnterCardView'
    'mousemove': -> @trigger 'mouseMoveCardView'
    'mouseleave': -> @trigger 'mouseLeaveCardView'

    'mouseenter .card-label.mod-card-front': 'labelMouseEnter'
    'mouseleave .card-label.mod-card-front': 'labelMouseLeave'

    'dd-enter:files': 'dragenter'
    'dd-leave:files': 'dragleave'
    'dd-drop:files': 'dropFiles'
    'dd-enter:url': 'dragenter'
    'dd-leave:url': 'dragleave'
    'dd-drop:url': 'dropUrl'

    'pasteinput:files': 'dropFiles'
    'pasteinput:url': 'dropUrl'

  initialize: ->
    for opt in ['filterDeactivated', 'applyBoardCardFilter', 'trackApdex']
      if @options[opt]?
        @[opt] = @options[opt]

    PostRender.enqueue "initialize_cardview_#{ @cid }", =>
      # Since PostRender runs this on the browser's next idle period, assume
      # this wasn't run immediately and we missed some socket updates, so
      # re-render to catch up.
      @render()

      @makeDebouncedMethods 'render',
        'renderName',
        'renderLabels'
        'renderCover'
        'renderFiltered'
        'renderPowerUpEffects'
        'renderStickers'
        'renderBadges'
        'renderDueComplete'
        'renderCustomFieldItems'
        'updateDateBadges'

      @listenTo @model,
        'change:name': @renderNameDebounced
        'change:labels': @renderLabelsDebounced
        'change:idAttachmentCover change:cover': @renderCoverDebounced
        'change:name change:labels change:idLabels change:due change:dueComplete': @renderFilteredDebounced
        'change:due change:badges': @updateRenderIntervalSubscription
        'change:dueComplete': @renderDueComplete
        'change:dateLastActivity': =>
          @renderCoverDebounced()
          @renderPowerUpEffectsDebounced()
        'change:badges change:due change:subscribed change:isTemplate': @renderBadgesDebounced
        'keyboardMove': @scrollIntoView

      @listenTo @model.customFieldItemList, 'add remove reset change', @frameDebounce ->
        @renderCustomFieldItems()
        @renderFiltered()

      @listenTo @modelCache, "add:Notification remove:Notification change:Notification", @renderBadgesDebounced

      @listenTo @model.memberList, 'change:initials change:avatarUrl change:avatarSource change:fullName change:username', @renderMembers

      # Don't attach two listeners to the same event! Single listener, 2 function calls
      @listenTo @model.memberList, 'add remove reset', @frameDebounce ->
        @renderMembers()
        @renderFiltered()

      @listenTo @model.labelList, 'add remove reset change',
        @renderLabelsDebounced

      @listenTo @model.stickerList,
        'add remove reset change sort': @renderStickersDebounced

      board = @model.getBoard()
      @listenTo board, 'change:powerUps change:prefs.cardAging', @renderPowerUpEffectsDebounced
      @subscribe pluginsChangedSignal(board, @model), =>
        @renderCoverDebounced()
        @renderPowerUpEffectsDebounced()
      @listenTo board.filter, 'change', @renderFilteredDebounced
      @listenTo board, 'change:labels', @renderLabelsDebounced
      # Possible for a user to become deactivated
      @listenTo board, 'change:memberships', @renderMembers
      @listenTo board, 'change:prefs.hideVotes', @renderBadgesDebounced

      @listenTo board.customFieldList, 'add remove reset change',
        @renderCustomFieldItemsDebounced

      @listenTo board.boardPluginList, 'add remove reset change', =>
        @renderCustomFieldItemsDebounced()
        @renderBadgesDebounced()

      @listenTo board.viewState, 'active-card-changed', @renderActiveState

      @listenTo board, 'permChange', @render

      # This is just here in case you're dragging a member somewhere before
      # we've managed to hook droppable. It won't work all the time; it's
      # just another cheap chance for us to get it right.
      @listenTo @, 'mouseEnterCardView', ->
        enqueueDroppable @

      @updateRenderIntervalSubscription()

    return

  isOnBoardTemplate: isOnBoardTemplate

  shouldRenderColorCover: ->
    return featureFlagClient.get('remarkable.rmk-239', false)

  shouldRenderFullCover: ->
    return featureFlagClient.get('remarkable.rmk-239', false)

  renderActiveState: ->
    # Don't ask me. This was here before. Should never happen, but who knows?
    if !@$el?
      return

    isActive = @model.getBoard().viewState.isCardSelected(@model)
    @$el.toggleClass 'active-card', isActive

    if isActive
      PasteInput.addHandler(@, { scope: 'card' })
      registerShortcutHandler(@onShortcut, { scope: Scope.Card })
    else
      PasteInput.removeHandler(@)
      unregisterShortcutHandler(@onShortcut, { scope: Scope.Card })
    return

  remove: ->
    unregisterShortcutHandler(@onShortcut)
    super

  onShortcut: (event) =>
    loggedIn = Auth.isLoggedIn()
    editable = @model.editable()
    isTemplate = !!@model.get('isTemplate')
    onCalendar = @onCalendar
    key = getKey(event)

    switch key
      when Key.Enter
        @showDetail()
        event.preventDefault()
        track 'Keyboard Shortcuts', 'Enter - Open Card'

      when Key.e
        @openQuickCardEditor()
        event.preventDefault()
        track 'Keyboard Shortcuts', 'E - Open Quick Card Editor'

      when Key.t
        Controller.showCardDetail(@model, { runMethod: 'editTitle', method: 'via the T shortcut from card front' })
        event.preventDefault()
        track 'Keyboard Shortcuts', 'T - Open Card and Edit Title'

      when Key.Dash
        Controller.showCardDetail(@model, { runMethod: 'onChecklistShortcut', method: 'via the dash shortcut from card front' })
        event.preventDefault()
        track 'Keyboard Shortcuts', '- - Add Checklist'

      when Key.d
        if editable && !isTemplate
          @showPopOver(DatePickerView, { trackingCategory: 'keyboard shortcut' })
          event.preventDefault()
          track 'Keyboard Shortcuts', 'D - Due Dates', 'On Board View'

      when Key.l
        if editable
          @showPopOver(
            CardLabelSelectView,
            { hideOnSelect: false }
          )
          event.preventDefault()
          track 'Keyboard Shortcuts', 'L - Edit Labels', 'On Board View'

      when Key.Zero, Key.One, Key.Two, Key.Three, Key.Four, \
           Key.Five, Key.Six, Key.Seven, Key.Eight, Key.Nine
        if editable
          fxNoUniqueLabel = (color) =>
            @showPopOver(
              CardLabelSelectView,
              { searchInit: color, hideOnSelect: true }
            )
          LabelKeyHelper.setLabelFromKey(key, @model, fxNoUniqueLabel)
          event.preventDefault()
          track 'Keyboard Shortcuts', '0-9 - Toggle Specific Label'

      when Key.a, Key.m
        if editable && !@isOnBoardTemplate()
          @showPopOver(CardMemberSelectView)
          event.preventDefault()
          track 'Keyboard Shortcuts', 'A - Assign Members', 'Board View'

      when Key.Space
        board = @model.getBoard()
        isOnBoardTemplate = @isOnBoardTemplate()
        if editable && !isOnBoardTemplate && (board.hasActiveMembership(Auth.me()) || board.isEditableByTeamMemberAndIsNotABoardMember())
          # TODO: requestJoinBoard unecessary once WLRS-495 ships
          toggleMemberFn = => @model.toggleMember(Auth.myId())
          board.requestJoinBoard(toggleMemberFn)
          event.preventDefault()
          track 'Keyboard Shortcuts', 'Space - Toggle Assigning Self'

      when Key.c
        if editable
          @model.close()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'C - Archive Card'

      when Key.AngleRight, Key.Period
        if editable && !onCalendar
          @model.moveToNextList(if key == Key.AngleRight then 'top' else 'bottom')
          event.preventDefault()
          track 'Keyboard Shortcuts', '> - Move to Next List'

      when Key.AngleLeft, Key.Comma
        if editable && !onCalendar
          @model.moveToPrevList(if key == Key.AngleLeft then 'top' else 'bottom')
          event.preventDefault()
          track 'Keyboard Shortcuts', '< - Move to Previous List'

      when Key.v
        if loggedIn && !isTemplate
          @model.toggleVote()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'V - Vote'

      when Key.s
        if loggedIn && !@isOnBoardTemplate()
          subscribed = @model.get('subscribed')
          @model.subscribe(!subscribed)
          event.preventDefault()
          track 'Keyboard Shortcuts', 'S - Subscribe', if subscribed then 'Unsubscribe' else 'Subscribe'

  showPopOver: (viewClass, options = {}) ->
    PopOver.toggle
      elem: @$('.js-card-menu')
      view: viewClass
      options: _.extend({ @model, @modelCache, hideOnSelect: true }, options)

  render: ->
    log('render', "rendering card " + @model.get('name'))

    data = @model.toJSON()

    data.showCover = @showCover()
    data.showEditor =
      @model.editable() &&
      !@options.hideMenu

    if @model.hasStickers()
      data.hasStickers = true

    # render this stuff upfront so we don't have to thrash the layout again.
    data.labels = @labelsData()

    board = @model.getBoard()

    data.members = []
    for member in @model.memberList.models by -1
      memberData = member.toJSON()
      memberData.isVirtual = board.getOrganization()?.isVirtual(member) || board.isVirtual(member)
      memberData.isDeactivated = board.isDeactivated(member)

      data.members.push memberData

    # Needed to pre-render covers to reduce flickering when the card is moved around.
    data.cover = @model.get('cover')
    if @model.get('idAttachmentCover')
      data.attachmentCoverUrl = @model.attachmentList.get(@model.get('idAttachmentCover'))?.get('url')
    data.hideCover = !@model.getBoard().getPref('cardCovers') || @onCalendar
    data.hasCover = @model.hasCover()

    # add classes before adding to the DOM to prevent layout thrashing.
    @$el.toggleClass('js-archive-card', @model.get('closed'))

    if @showCover() && @model.hasCover()
      @$el.addClass('is-covered')

    if @model.hasStickers()
      @$el.addClass('is-stickered')

    @$el.html cardTemplate(data)

    @renderName()
    @renderFiltered()
    @renderBadges()
    @renderCustomFieldItems()
    @renderDueComplete()

    PostRender.enqueue "render_#{ @cid }", =>
      # make sure cards stay active when re-rendered
      @renderPluginBadges()
      @renderActiveState()
      @renderCover()
      @renderStickers()
      @renderPowerUpEffects()
      @waitForId @model, => @renderLink()

      # Hooking droppable is expensive. Use a worker queue.
      @_droppableHookedSinceRender = false
      enqueueDroppable @

    @

  # Hook a jquery.ui.droppable for dropping members from the sidebar
  # This is inordinately expensive to run, because of the width and height
  # calculations done in 'droppable', see the HOOK_DROPPABLE_QUEUE above
  hookDroppable: ->
    if Browser.isTouch()
      return
    # It's possible that we've been removed from the DOM/destroyed
    # If that's the case, then just abort
    if !@$el?
      return

    # We're using an event handler AND a queue, so only hook once per render
    if @_droppableHookedSinceRender
      return

    @_droppableHookedSinceRender = true

    if !Browser.isTouch()
      getFrame = @throttle ->
        $('.board-canvas')[0].getBoundingClientRect()
      , 100, { trailing: false }
      @$el.droppable
        refreshPositions: true
        inBounds: (e) ->
          # This is used to make sure we don't drop onto cards through the
          # sidebar. We have to recalculate this in case the user toggles
          # the sidebar with the keyboard shortcut.
          frame = getFrame()
          frame.left <= e.pageX < frame.right &&
          frame.top  <= e.pageY < frame.bottom
        accept: (el) =>
          if el.is('.js-list-draggable-board-members .member')
            return true
          if el.is('.js-draggable-sticker')
            return !@model?.isOverLimit?('stickers', 'perCard')
          return false
        hoverClass: 'active-card'
        drop: (e, ui) =>
          if ui.draggable.hasClass('member')
            dragged_mem_id = ui.draggable.data('id')
            dragged_mem = ui.draggable.clone()
            fInclude = @model.memberList.detect (member) -> member.id == dragged_mem_id

            if (!fInclude)
              @model.addMember(dragged_mem_id)
              track('Card', 'Add Member by Board Sidebar', undefined, @model.trackProperty())

          else if ui.draggable.hasClass('js-draggable-sticker')
            sticker = ui.draggable.data('sticker')

            borderTopWidth = borderLeftWidth = borderRightWidth = 1

            # Figure out where the sticker area would be, if the card had a
            # sticker area
            stickerOffset = ui.helper.offset()
            targetOffset =
              top: @$el.offset().top + borderTopWidth
              left: @$el.offset().left + borderLeftWidth

            targetWidth = @$el.outerWidth() - borderLeftWidth - borderRightWidth

            offsetLeft = stickerOffset.left - targetOffset.left
            offsetTop = stickerOffset.top - targetOffset.top

            left = (offsetLeft / targetWidth) * 100
            stickerAreaHeight = @$('.js-card-stickers').height()

            if @$el.hasClass('is-stickered') || @$el.hasClass('is-covered')
              top = (offsetTop / stickerAreaHeight) * 100
            else
              # This card doesn't have anything on it yet; it's unlikely that
              # you're trying to place it at an exact vertical position, and
              # putting it right where you drop it will put part of the sticker
              # off of the card
              top = 0

            # if the user tries to put the sticker below the valid area, move
            # it as far down as possible
            if top > stickerAreaHeight
              top = stickerAreaHeight

            transformMatrix = Util.getElemTransformMatrix(ui.helper.find('.sticker-select-fixed'))
            if transformMatrix?
              rotate = Util.getMatrixDegrees(transformMatrix) % 360
            else
              rotate = 0

            @addNewStickerToList(sticker, left, top, rotate)

          return

    return


  addNewStickerToList: addNewStickerToList

  showStickers: showStickers

  renderStickers: renderStickers

  renderName: renderName

  renderLink: ->
    url = Controller.getCardUrl(@model)

    @$el.attr('href', url)

    @

  renderCustomFieldItems: renderCustomFieldItems

  renderPluginBadges: renderPluginBadges

  showCover: showCover

  renderFiltered: (e) ->
    return if @options.dontFilter?

    @_visible ?= true
    board = @model.getBoard()
    # You can see the card if you aren't looking at it's board, or it matches
    # the filter of the board you're looking at
    visible = !board? ||
      !Controller.onBoardView(board.id) ||
      !@applyBoardCardFilter ||
      board.filter.satisfiesFilter(@model)
    if @_visible != visible
      # We set the height in order to help out dragsort.
      # http://stackoverflow.com/questions/9440664
      @$el.toggleClass('hide', !visible).height(if visible then "" else 0)
      @_visible = visible
    @

  renderDueComplete: renderDueComplete

  renderPowerUpEffects: renderPowerUpEffects

  openQuickCardEditor: openQuickCardEditor

  labelClick: labelClick

  labelMouseEnter: labelMouseEnter

  labelMouseLeave: labelMouseLeave

  moveToCalendarDay: moveToCalendarDay

  moveInCalendarDay: moveInCalendarDay

  moveTo: moveTo

  moveIn: moveIn

  showDetail: (e) ->
    if e && (e.ctrlKey || e.metaKey || e.shiftKey)
      return

    # Stop the event so we don't end up running the click handler for the URL
    # as well.
    # This must run first if this event fires with no modifier keys.
    # otherwise it exposes a firefox bug where dropping the card
    # can cause the card detail to open
    Util.stop(e)


    # We don't want to open the card detail if we're in the middle of
    # dragging a card around; the "click" is probably the member dropping
    # the card
    if DragSort.sorting
      return

    if @options.trackEvent
      @options.trackEvent()

    if @trackApdex
      Apdex.start(
        task: 'cardFromBoard',
        taskId: @model.id,
      )

    Controller.showCardDetail(@model, {
      runMethod: if @model.shouldSuggestDescription() then 'expandDesc'
      method: 'from card front' ,
    })

    if @trackApdex
      Apdex.stop(
        task: 'cardFromBoard',
        taskId: @model.id,
      )

  dragenter: dragenter

  dragleave: dragleave

  dropFiles: dropFiles

  dropUrl: dropUrl

  scrollIntoView: ->
    # Usually just .scrollIntoView() would do
    # but IE10 scrolls the whole thing to the left
    board = @$el.closest('#board')
    list = @$el.closest('.js-list')
    listRect = list[0].getBoundingClientRect()
    scrollDelta = listRect.left + listRect.width - window.innerWidth

    @$el.closest('.js-list-cards').scrollTop(@$el.position().top)

    if listRect.left < 0
      board.animate({ scrollLeft: list.position().left }, 150)
    else if scrollDelta > 0
      board.animate({ scrollLeft: board.scrollLeft() + scrollDelta }, 150)

  updateRenderIntervalSubscription: ->
    if @model.get('due') || (@advancedChecklistsV2Enabled && @model.get('badges')?.checkItemsEarliestDue)
      @listenTo Dates, 'renderInterval', @updateDateBadgesDebounced
      return
    @stopListening Dates, 'renderInterval', @updateDateBadgesDebounced
